/** How Sentry should run for this deployment, as resolved from config. */
export interface SentrySettings {
	/** The Sentry environment name, e.g. 'dev-gb', 'production-loanlogics' or 'local'. */
	environment: string;
	/** Whether Sentry should be initialised at all. */
	enabled: boolean;
	/** Fraction of transactions traced, e.g. 0.1 samples 10%. */
	tracesSampleRate: number;
}

/**
 * Resolve how Sentry should run for this deployment.
 *
 * The validation server generates `config.js` from its own configuration and
 * the deployment sets `sentryEnvironment` there (e.g. `gb`, `dev-loanlogics`).
 * When it is unset — local development, served from
 * `static/config.js` — Sentry stays off unless forced on for testing.
 */
export const resolveSentrySettings = (
	config: { sentryEnvironment?: string },
	forcedOn: boolean
): SentrySettings => {
	const environment = config.sentryEnvironment || 'local';

	return {
		environment,
		enabled: Boolean(config.sentryEnvironment) || forcedOn,
		// Development environments and local testing get full traces; production is sampled.
		tracesSampleRate: environment.startsWith('dev') || environment === 'local' ? 1.0 : 0.1
	};
};
